import {WALLET_INVESTMENT_RISK} from '../Reducer/WalletInvestmentRiskReducer';
import {ApiWalletInvestmentRisk} from '../Api';

export function WalletInvestmentRiskThunk() {
    return (dispatch,getState)=>{
        ApiWalletInvestmentRisk()
        .then((result)=>{
            dispatch({
                type:WALLET_INVESTMENT_RISK,
                payload:{
                    result:result.data.data
                }
            })
        })
    }
}